import React, { useEffect } from "react"
import { useImmerReducer } from "use-immer"

import Header from "./Header"
import Footer from "./Footer"
import AddNote from "./AddNote"

import Axios from "axios"
import { BrowserRouter, Switch, Route } from "react-router-dom"
import HomeGuest from "./HomeGuest"
// import Home from "./Home"
import FlashMessages from "./FlashMessages"

import StateContext from "../StateContext"
import DispatchContext from "../DispatchContext"
import Page from "./Page"

Axios.defaults.baseURL = "https://pundhir-keeper-backend.herokuapp.com"
function App() {
  const initialState = {
    loggedIn: Boolean(localStorage.getItem("userToken")),
    flashMessages: [],

    userData: {
      user: {
        _id: localStorage.getItem("userId"),
        name: localStorage.getItem("userName"),
        email: localStorage.getItem("userEmail")
      },
      token: localStorage.getItem("userToken")
    },
    notes: []
  }

  function ourReducer(draft, action) {
    switch (action.type) {
      case "login":
        draft.loggedIn = true
        draft.userData = action.data
        return
      case "logout":
        draft.loggedIn = false
        return
      case "flashMessage":
        draft.flashMessages.push(action.value)
        return
      case "addNote":
        draft.notes.push(action.data)
        return
      default:
        return
    }
  }

  //state for rendering header
  // const [loggedIn, setLoggedIn] = useState()
  // const [flashMessages, setFlashMessages] = useState([])

  //previously using useReducer
  // const [state, dispatch] = useReducer(ourReducer, initialState)
  const [state, dispatch] = useImmerReducer(ourReducer, initialState)

  useEffect(() => {
    if (state.loggedIn) {
      // console.log("Username is", state.user)
      localStorage.setItem("userToken", state.userData.token)
      localStorage.setItem("userId", state.userData.user._id)
      localStorage.setItem("userName", state.userData.user.name)
      localStorage.setItem("userEmail", state.userData.user.email)
    } else {
      localStorage.removeItem("userToken")
      localStorage.removeItem("userId")
      localStorage.removeItem("userName")
      localStorage.removeItem("userEmail")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.loggedIn])
  //function for flashMessages using useState
  // function addFlashMessage(msg) {
  //   setFlashMessages(prev => prev.concat(msg))
  // }

  return (
    <StateContext.Provider value={state}>
      <DispatchContext.Provider value={dispatch}>
        <BrowserRouter>
          <Switch>
            <Route path="/" exact>
              <Header />
              <FlashMessages messages={state.flashMessages} />
              {state.loggedIn ? (
                <Page title="Note it!📝">
                  <AddNote />
                </Page>
              ) : (
                <HomeGuest />
              )}
              <Footer />
            </Route>
          </Switch>
        </BrowserRouter>
      </DispatchContext.Provider>
    </StateContext.Provider>
  )
}

export default App
